import * as types from "@/store/types";

const state = {
  init: [],
  supports: []
};

const getters = {
  [types.init.getters.GET_INIT_DATA]: state => {
    return state.init;
  },
  [types.init.getters.GET_SUPPORT]: state => {
    return state.supports;
  }
};

const mutations = {
  [types.init.mutations.MUTATE_INIT_DATA]: (state, payload) => {
    state.init = payload;
  },

  [types.init.mutations.MUTATE_SUPPORT_DATA]: (state, payload) => {
    state.supports = payload;
  }
};

const actions = {
  [types.init.actions.SET_INIT_DATA]: ({ commit }, payload) => {
    commit(types.init.mutations.MUTATE_INIT_DATA, payload);
  },
  [types.init.actions.SET_SUPPORT_DATA]: ({ commit }, payload) => {
    commit(types.init.mutations.MUTATE_SUPPORT_DATA, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
